
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/display/loading-and-empty-states",
      function () {
        return require("private-next-pages/x/react-chat/display/loading-and-empty-states.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/display/loading-and-empty-states"])
      });
    }
  